var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"center"},[_c('p',{staticClass:"parcandi-title"},[_vm._v(" Parcandi.ch ")])])}
var staticRenderFns = []

export { render, staticRenderFns }